import(/* webpackMode: "eager" */ "/app/apps/tierra-bonita/app/[locale]/not-found.tsx");
